import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

const LinkIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 20 20'} fill="none" {...props}>
    <path
      fill="none"
      d="M8.33337 10.8333C8.69125 11.3118 9.14784 11.7077 9.67217 11.9941C10.1965 12.2806 10.7763 12.4509 11.3722 12.4936C11.9682 12.5363 12.5664 12.4503 13.1262 12.2415C13.686 12.0327 14.1943 11.7059 14.6167 11.2833L17.1167 8.78335C17.8757 7.9975 18.2957 6.94499 18.2862 5.85251C18.2767 4.76002 17.8385 3.71497 17.066 2.94243C16.2934 2.1699 15.2484 1.7317 14.1559 1.7222C13.0634 1.71271 12.0109 2.13269 11.225 2.89168L9.79171 4.31668"
      stroke="#394860"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M11.6666 9.16665C11.3087 8.68821 10.8521 8.29233 10.3278 8.00587C9.80347 7.7194 9.22367 7.54905 8.62771 7.50637C8.03176 7.46369 7.4336 7.54968 6.8738 7.7585C6.314 7.96732 5.80566 8.29409 5.38326 8.71665L2.88326 11.2167C2.12426 12.0025 1.70429 13.055 1.71378 14.1475C1.72327 15.24 2.16148 16.285 2.93401 17.0576C3.70655 17.8301 4.7516 18.2683 5.84408 18.2778C6.93657 18.2873 7.98908 17.8673 8.77492 17.1083L10.1999 15.6833"
      stroke="#394860"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
export default LinkIcon
